export const getInitialLocaleValues = l => {
  return Object.keys(l).reduce((accumulator, currentValue) => {
    accumulator[currentValue] = ""
    return accumulator
  }, {})
}
